module.exports = __webpack_public_path__ + "static/img/CA black 1 (2).5abe1bf2.png";